import { useState, useCallback } from 'react';

/**
 * Toast-State + Push-Funktion.
 * `pushToast(text, type='info', ms=3500)` zeigt Banner.
 * Returns [toasts, push].
 */
export default function useToast() {
  const [toasts, setToasts] = useState([]);
  const push = useCallback((text, type = 'info', ms = 3500) => {
    const id = Date.now() + Math.random();
    setToasts(p => [...p, { id, text, type }]);
    setTimeout(() => setToasts(p => p.filter(t => t.id !== id)), ms);
  }, []);
  return [toasts, push];
}
